var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBankInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_402_32395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.60798 2.81655H12.8638C13.3085 2.81655 13.6678 3.18145 13.6678 3.6331V5.4091C13.9241 5.30703 14.1979 5.25855 14.4718 5.2662V3.6331C14.4718 2.73234 13.7507 2 12.8638 2H1.60798C0.721077 2 0 2.73234 0 3.6331V10.1655C0 11.0663 0.721077 11.7986 1.60798 11.7986H8.29616L8.49715 10.9821H1.60798C1.16327 10.9821 0.803989 10.6172 0.803989 10.1655V3.6331C0.803989 3.18145 1.16327 2.81655 1.60798 2.81655ZM2.81396 7.71586C2.59286 7.71586 2.41197 7.89958 2.41197 8.12413C2.41197 8.34868 2.59286 8.53241 2.81396 8.53241H9.24587C9.46696 8.53241 9.64786 8.34868 9.64786 8.12413C9.64786 7.89958 9.46696 7.71586 9.24587 7.71586H2.81396ZM2.41197 5.67448C2.41197 5.89903 2.59286 6.08275 2.81396 6.08275H11.6578C11.8789 6.08275 12.0598 5.89903 12.0598 5.67448C12.0598 5.44993 11.8789 5.2662 11.6578 5.2662H2.81396C2.59286 5.2662 2.41197 5.44993 2.41197 5.67448ZM14.6426 7.10344L15.0798 7.54744C15.2356 7.70565 15.2356 7.96592 15.0798 8.12413L14.4567 8.75696L13.4517 7.73627L14.0748 7.10344C14.2306 6.94524 14.4869 6.94524 14.6426 7.10344ZM10.2132 11.0254L12.8814 8.31551L13.8864 9.3362L11.2156 12.0461C11.1629 12.0997 11.1001 12.1354 11.0297 12.1533L9.79861 12.4672L10.1076 11.2168C10.1252 11.1454 10.1629 11.079 10.2132 11.028V11.0254ZM13.5045 6.52675L9.64284 10.4487C9.48706 10.607 9.37903 10.8034 9.32627 11.0178L8.85644 12.929C8.82126 13.0694 8.86146 13.2148 8.96196 13.3169C9.06246 13.419 9.20567 13.4598 9.34385 13.4241L11.2257 12.9469C11.4367 12.8933 11.6302 12.781 11.786 12.6254L15.6476 8.70082C16.1175 8.22365 16.1175 7.44793 15.6476 6.9682L15.2105 6.5242C14.7406 6.04703 13.9768 6.04703 13.5045 6.5242V6.52675Z",
    fill: "#149CE0",
    stroke: "#149CE0",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_32395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankInfo);
export default __webpack_public_path__ + "static/media/bank-info.bfce816ff134c7d4e1c79571f13efdcc.svg";
export { ForwardRef as ReactComponent };